module.exports = __webpack_public_path__ + "assets/img/yukon-relax.b175a138.png";